import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sortable from "sortablejs";
import request from "@/utils/request";
import { EventBus } from "@/api/event-bus";
export default {
  name: "Weforsys-table-draggable",
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 序号 默认有
    hasNO: {
      type: Boolean,
      default: true
    },
    // 多选框 默认无
    hasC: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    height: {
      default: "100%"
    },
    reftext: {
      default: "WeforsysTables"
    },
    col: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dropCol: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onlyid: {
      default: ""
    },
    transvalue: {
      default: ""
    }
  },
  data: function data() {
    return {
      datas: [],
      pageConfig: [],
      collist: [],
      visibles: false
    };
  },
  created: function created() {
    this.initData();
    EventBus.$on("executeMethod", this.getColumnWidths);
  },
  beforeDestroy: function beforeDestroy() {
    EventBus.$off("executeMethod", this.getColumnWidths);
  },
  mounted: function mounted() {},
  watch: {
    data: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    },
    columnData: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    }
  },
  activated: function activated() {
    var _this = this;
    // 解决缓存出现的表格错位问题
    this.$nextTick(function () {
      _this.$refs[_this.reftext].doLayout();
    });
  },
  methods: {
    setup: function setup() {
      this.visibles = true;
    },
    getColumnWidths: function getColumnWidths() {
      var _this2 = this;
      var columnWidths = [];
      this.$nextTick(function () {
        var headers = _this2.$refs[_this2.reftext].store.states.columns;
        var arr = [];
        console.log(headers, "headers");
        headers.forEach(function (header) {
          var width = 0;
          _this2.pageConfig.forEach(function (element) {
            if (element.Columns == header.label) {
              if (header.realWidth == null) {
                element.Width = Math.floor(header.width);
              } else {
                element.Width = Math.floor(header.realWidth);
              }
            }
          });
        });
        EventBus.$emit("customEvents", {
          message: _this2.pageConfig
        });
      });
    },
    initData: function initData() {
      var _this3 = this;
      request({
        url: "/api/WMS/TableAdjustmentConfig/SelectTableAdjustmentConfig?pageType=".concat(this.transvalue),
        method: "get"
      }).then(function (res) {
        _this3.pageConfig = [];
        if (res.data.length == 0) {
          _this3.col.forEach(function (element) {
            _this3.pageConfig.push({
              Columns: element.label,
              Index: "true"
            });
          });
        } else {
          _this3.pageConfig = res.data;
        }
        console.log(_this3.pageConfig, "this.pageConfig11111");
        _this3.collist = [];
        if (_this3.pageConfig[0] != undefined) {
          _this3.pageConfig.forEach(function (element) {
            _this3.col.forEach(function (elements) {
              if (element.Columns == elements.label && element.Index == "true") {
                _this3.collist.push({
                  label: element.Columns,
                  prop: elements.prop,
                  Width: element.Width,
                  Index: element.Index
                });
              }
            });
          });
        } else {
          _this3.pageConfig = [];
        }
      });
    },
    changes: function changes(newWidth, oldWidth, column, event) {
      this.getColumnWidths();
    },
    save: function save(row, rows) {
      var _this4 = this;
      if (this.pageConfig.length == 0) {
        this.col.forEach(function (element, index) {
          _this4.pageConfig.push({
            Columns: row[index],
            Width: rows[index],
            Index: "true"
          });
        });
      } else {
        this.pageConfig.forEach(function (element, index) {
          //
          if (_this4.hasC == false) {
            element.Width = rows[index];
          } else {
            element.Width = rows[index + 1];
          }
        });
      }
      console.log(this.pageConfig, "this.pageConfig");

      // console.log(this.pageConfig, "this.pageConfig");
      // request({
      //   url: `/api/WMS/TableAdjustmentConfig/SetTableAdjustmentConfig`,
      //   method: "post",
      //   data: {
      //     pageType: this.transvalue,
      //     pageConfig: this.pageConfig
      //   }
      // }).then(res => {
      //   this.$message({
      //     message: res.msg,
      //     type: "success",
      //     duration: 1000
      //   });

      //   window.location.reload();
      // });
    },
    indexMethod: function indexMethod(index) {
      if (this.currentPage != undefined && this.pageSize != undefined) {
        return (this.currentPage - 1) * this.pageSize + index + 1;
      } else {
        return index + 1;
      }
    },
    doLayout: function doLayout() {
      var _this5 = this;
      setTimeout(function () {
        _this5.$nextTick(function () {
          _this5.$refs[_this5.reftext].doLayout();
        });
      }, 50);
    }
  }
};